import { useEffect } from 'react';
import { useSettings } from '@/contexts/SettingsContext';

export const Favicon: React.FC = () => {
  const { getFavicon, loading } = useSettings();
  const faviconUrl = getFavicon();

  useEffect(() => {
    if (!loading && faviconUrl) {
      // Remove existing favicon links
      const existingLinks = document.querySelectorAll("link[rel*='icon']");
      existingLinks.forEach((link) => link.remove());

      // Create new favicon link
      const link = document.createElement('link');
      link.rel = 'icon';
      link.type = faviconUrl.endsWith('.ico') ? 'image/x-icon' : 'image/png';
      link.href = faviconUrl;
      document.head.appendChild(link);
    }
  }, [faviconUrl, loading]);

  return null;
};

